import styled from 'styled-components'

const MyDiv = styled.div`
margin-top:100px;
margin-bottom: 100px;
`
export default MyDiv
